var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaybuttonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0375 7.20217L5.42708 0.395915C4.85535 0.110041 4.22003 -0.0249404 3.58145 0.00379029C2.94287 0.032521 2.32224 0.22401 1.77849 0.560073C1.23474 0.896135 0.785915 1.36562 0.474644 1.92393C0.163373 2.48225 -1.37852e-05 3.11086 8.72352e-10 3.75008V16.6168C-1.37852e-05 17.256 0.163373 17.8846 0.474644 18.4429C0.785915 19.0012 1.23474 19.4707 1.77849 19.8068C2.32224 20.1428 2.94287 20.3343 3.58145 20.363C4.22003 20.3918 4.85535 20.2568 5.42708 19.9709L19.0375 13.1647C21.4958 11.9355 21.4958 8.43133 19.0375 7.20217Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybuttonIcon);
export default __webpack_public_path__ + "static/media/PlaybuttonIcon.a85b90f39384e11c56c4a0cf5ab0f988.svg";
export { ForwardRef as ReactComponent };